import React from "react";
import {
  FooterContainer,
  TextContainer,
  IconContainer,
  Icon,
  FooterStyles,
  SecondTextContainer,
} from "./CustomFooterStyles";
import useEmpresa from "../../hooks/useEmpresa";
import Text from "../Common/Text";
import CustomSeparator from "../Common/CustomSeparator";

const CustomFooter = (props) => {
  const empresa = useEmpresa();

  return (
    <FooterContainer
      footerPosition={props.footerPosition}
      footerWidth={props.footerWidth}
      footerBorderColor={empresa?.COLOR_PRINCIPAL}
    >
      <TextContainer>
        <Text color={empresa?.COLOR_PRINCIPAL} margin={"0"}>
          © 2023 {empresa?.NOMBRE}, todos los derechos reservados |
        </Text>
        <CustomSeparator width={"7px"} />
        <IconContainer>
          <Icon
            href={empresa?.REDES.FACEBOOK.URL}
            target="_blank"
            rel="noopener noreferrer"
          >
            <img
              src={empresa?.REDES.FACEBOOK.ICON}
              alt="Logo"
              style={FooterStyles.imgSocialIcon}
            />
          </Icon>
          <Icon
            href={empresa?.REDES.TWITTER.URL}
            target="_blank"
            rel="noopener noreferrer"
          >
            <img
              src={empresa?.REDES.TWITTER.ICON}
              alt="Logo"
              style={FooterStyles.imgSocialIcon}
            />
          </Icon>
          <Icon
            href={empresa?.REDES.INSTAGRAM.URL}
            target="_blank"
            rel="noopener noreferrer"
          >
            <img
              src={empresa?.REDES.INSTAGRAM.ICON}
              alt="Logo"
              style={FooterStyles.imgSocialIcon}
            />
          </Icon>
          <Icon
            href={empresa?.REDES.YOUTUBE.URL}
            target="_blank"
            rel="noopener noreferrer"
          >
            <img
              src={empresa?.REDES.YOUTUBE.ICON}
              alt="Logo"
              style={FooterStyles.imgSocialIcon}
            />
          </Icon>
        </IconContainer>
      </TextContainer>

      <SecondTextContainer>
        <Text color={empresa?.COLOR_PRINCIPAL} margin={"0"}>
          Mapa del Sitio | Privacidad
        </Text>
      </SecondTextContainer>
    </FooterContainer>
  );
};

export default CustomFooter;